
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M19.368 8.633c-5.529 1.455-9.399.857-11.71-.126a2.2 2.2 0 0 0-.104.663v7.444c0 1.186.961 2.148 2.148 2.148h22.555a2.15 2.15 0 0 0 2.148-2.148V9.17q0-.207-.038-.404c-3.93-.987-9.456-1.592-14.999-.133M23.665 30.651h-5.37v13.963h5.37z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"M35.926 10.87V7.648A2.15 2.15 0 0 0 33.778 5.5H11.222a2.15 2.15 0 0 0-2.148 2.148v6.445c0 1.186.962 2.148 2.148 2.148h22.556a2.15 2.15 0 0 0 2.148-2.149zm0 0h3.222V20L22.5 24.296v4.833m0 0h-2.685v13.963h5.37V29.13z"}})])
          )
        }
      }
    